import { FC } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';

export const PanelControls: FC<{ onPopoutAction?: () => void; onMinimizeAction?: () => void }> = ({
  onPopoutAction,
  onMinimizeAction,
}) => {
  const { t } = useTranslation('aiOnboarding');
  return (
    <div css={styles.container}>
      <Button variant='secondary' iconName='pop-out-small' label={t('Pop Out')} onClick={onPopoutAction} />
      <Button variant='secondary' iconName='minus-small' label={t('Minimize')} onClick={onMinimizeAction} />
    </div>
  );
};

const styles = {
  container: css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing(0.5)};
  `,
};
